import { _ as __read } from '../../_tslib-7a01aab4.js';
import { useRef, useState, useMemo, useEffect } from 'react';

var useClickOutside = function (isCapture, isStopPropagation) {
    if (isCapture === void 0) { isCapture = false; }
    if (isStopPropagation === void 0) { isStopPropagation = false; }
    var ref = useRef();
    var _a = __read(useState({
        hasClickedOutside: false,
    }), 2), state = _a[0], setState = _a[1];
    function handleEvent(e) {
        if (isStopPropagation) {
            e.stopPropagation();
        }
        setState({ hasClickedOutside: false });
        if (ref && ref.current) {
            setState({ hasClickedOutside: !ref.current.contains(e.target) });
        }
    }
    var currentEvent = useMemo(function () {
        if (window.MouseEvent)
            return 'mousedown';
        if (window.PointerEvent)
            return 'pointerdown';
        if (window.TouchEvent)
            return 'touchstart';
    }, []);
    useEffect(function () {
        document.addEventListener(currentEvent, handleEvent, isCapture);
        return function () {
            document.removeEventListener(currentEvent, handleEvent, isCapture);
        };
    }, [currentEvent]);
    return [ref, state.hasClickedOutside];
};

export { useClickOutside };
